import { addRtkQueryBridges, buildSlice, CommonState } from '~libs/reduxUtils';
import { Appointment } from '~weekly-planner/lib/common';

import { rejectedApi, typePrefix } from '~weekly-planner/actions/appointments/rejected';

interface State extends CommonState<Appointment> {
  params: { [key: string]: any };
  count?: number;
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  params: { limit: 30 },
};

const slice = buildSlice<State, Appointment>(typePrefix, initialState, {
  extraReducers: (builder) => {
    addRtkQueryBridges<State, Appointment>(builder, [
      {
        endpoint: rejectedApi.endpoints.getRejected,
        mode: 'list',
        apply: (state, payload: any) => {
          state.loading = 'fulfilled';
          const normalized = Array.isArray(payload)
            ? { rows: payload, total: payload.length }
            : (payload ?? { rows: [], total: 0 });
          state.rows = normalized.rows ?? [];
          state.count = normalized.total ?? 0;
          state.hasLoaded = true;
        },
        onPending: (state) => {
          state.loading = 'pending';
        },
        onRejected: (state) => {
          state.loading = 'error';
        },
      },
    ]);
  },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
